import { BaseLayout, DefaultErrorBoundary } from '@uag/react-core';
import { Outlet } from 'react-router-dom';

import { applicationInsightsReactPlugin } from 'utils/applicationInsights';

import { BrandHeaderBar } from './catalog/components/BrandHeaderBar';
import { UserLocaleSync } from './UserLocaleSync';

export const Frame = () => {
    return (
        <DefaultErrorBoundary reactPlugin={applicationInsightsReactPlugin}>
            {/* Both are page-independent app chrome, so they live here rather than in every page:
                BrandHeaderBar puts a non-DOKA brand's logo into the header bar (FitToViewport repaints
                the bar itself; renders nothing for DOKA, see branding.ts), UserLocaleSync preselects
                the language from the token. */}
            <BrandHeaderBar />
            <UserLocaleSync />
            <BaseLayout
                innerClassName="h-full bg-[#f4f4f4]"
                isPortalNavigationVisible={true}
                showFooter={false}
                showHeader={false}
            >
                <Outlet />
            </BaseLayout>
        </DefaultErrorBoundary>
    );
};
